import { useCallback, useEffect, useState } from 'react'

import { consumePendingOpenDocumentId } from '../utils/pendingOpenDocument'

interface UseOpenDocumentIdFromStorageResult {
  clearOpenDocumentId: () => void
  openDocumentId: string | null
}

export const useOpenDocumentIdFromStorage = (): UseOpenDocumentIdFromStorageResult => {
  const [openDocumentId, setOpenDocumentId] = useState<string | null>(null)

  useEffect(() => {
    const pendingDocumentId = consumePendingOpenDocumentId()
    if (pendingDocumentId) {
      setOpenDocumentId(pendingDocumentId)
    }
  }, [])

  const clearOpenDocumentId = useCallback(() => setOpenDocumentId(null), [])

  return { clearOpenDocumentId, openDocumentId }
}
